import { render, staticRenderFns } from "./TableProvissaoComissao.vue?vue&type=template&id=075c2ee4&scoped=true&"
import script from "./TableProvissaoComissao.vue?vue&type=script&lang=js&"
export * from "./TableProvissaoComissao.vue?vue&type=script&lang=js&"
import style0 from "./TableProvissaoComissao.vue?vue&type=style&index=0&id=075c2ee4&scoped=true&lang=css&"
import style1 from "./TableProvissaoComissao.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075c2ee4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
